import React from 'react';

function ExplainerHeader({ steps, currentGroup, handleGroupStepClick, currentStep }) {



  const stepHeaderTitles = {
    'Samenstellen': 'Eerst willen we jouw energiebehoefte in kaart brengen',
    'Aanbieding': 'We hebben de volgende aanbieding voor je',
    'Gegevens': 'Om klant te worden hebben we een aantal aanvullende gegevens van je nodig',
    'Bestellen': 'Ben je klaar om te profiteren van dynamisch en vast?',
    'Bedankt': 'Super, we zijn je dankbaar voor het vertrouwen'
  };

  const stepHeaderDescriptions = {
    'Samenstellen': 'Aan de hand van jouw energiebehoefte maken we een berekening die is gebaseerd op de actuele dynamische tarieven. Bij ons heb je het voordeel dat, nadat je klant bent geworden, je deze tarieven gedeeltelijk of volledig vast kunt zetten.',
    'Aanbieding': 'Hieronder vindt je jouw aanbod. De prijzen zijn een indicatie en kunnen afwijken van de uiteindelijke prijs.',
    'Gegevens': 'We gaan uiteraard veilig om met je persoonsgegevens.',
    'Bestellen': 'Na de inzending sturen wij de offerte naar je e-mail. Na akkoord op de offerte wordt de bestelling definitief.',
    'Bedankt': ''
  };

  const headerTitle = stepHeaderTitles[currentGroup];
  const headerText = stepHeaderDescriptions[currentGroup];

  return (
    <div className="aanmeldstraat-explainer d-none d-sm-block">
      <div className="text-container">
        <div className="container-profile-card">
          <div className="profile-card">
            <div className="profile-picture">
            <img alt="Expert Sophie"
                 src="/themes/custom/cleanenergy_barrio/images/aanmeldstraat/klantenservice.jpg"
                 className="profile-image" />
            </div>
              <div className="profile-info">
                <p className="profile-name">Sophie</p>
                <p className="profile-title">Expert Dynamische Energiecontracten</p>
              </div>
          </div>

          <div className="advice-section">
            <svg filter="drop-shadow(0px -4px 3px rgba(0, 0, 0, 0.1))" viewBox="0 0 27 17" className="speak-triangle">
              <path d="M10.1846 1.9125L0 17.0008H27L16.8154 1.9125C15.2295 -0.436976 11.7705 -0.436981 10.1846 1.9125Z"
                    fill="#5f4493"></path>
            </svg>
            <div className="advice-content">
              <h4 className="advice-heading">{headerTitle}</h4>
              <p className="advice-description">{headerText}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

};


export default ExplainerHeader;
